



// 处理商品价格符号

const yuan = (value = 0) => {

  var p = parseFloat(value);

  var isDot = ((p.toString()).indexOf(".")) != -1;

  var fix = !isDot ? 0 : 2;

  return "¥ " + p.toFixed(fix);

}


// 处理价格转为保留小数点后两位字符串

const priceToFixed = (value = 0, yuan) => {

  return (yuan ? yuan + parseFloat(value / 100).toFixed(2) : parseFloat(value / 100).toFixed(2))

}


//时间戳转日期 
const formatDate1 = (value) => {
  let date = new Date(value * 1000);
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? ('0' + MM) : MM;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let m = date.getMinutes();
  m = m < 10 ? ('0' + m) : m;
  let s = date.getSeconds();
  s = s < 10 ? ('0' + s) : s;
  return y + '-' + MM + '-' + d;
}

//时间戳转日期带时分秒

const formatDate = (value) => {
  let date = new Date(value * 1000);
  let y = date.getFullYear();
  let MM = date.getMonth() + 1;
  MM = MM < 10 ? ('0' + MM) : MM;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let m = date.getMinutes();
  m = m < 10 ? ('0' + m) : m;
  let s = date.getSeconds();
  s = s < 10 ? ('0' + s) : s;
  return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s;
}




// 当数量超过5位数时，以w替代

const praise = (value) => {

  let num = 0;

  if (value > 10000) {

    num = (value - (value % 1000)) / 10000 + "w";

  } else {

    num = value;

  }

  return num;

}





export {


  formatDate,

  formatDate1,

  yuan,

  priceToFixed,


  praise

}


// WEBPACK FOOTER //
// ./src/utils/filter.js